/**
 * Ops notification types that must show sidebar dots even when the PO is
 * terminal or only exists in poArchive (Pay Invoices, Shipment Archive, etc.).
 */
import {
  BROKER_SHIPPER_SIDEBAR_NOTIFICATION_TYPES,
  CARRIER_SIDEBAR_NOTIFICATION_TYPES,
} from './notificationSidebarAllocation';
import { NOTIFICATION_TYPES } from './notificationTypes';

const PAYMENTS_OPS_TYPES = new Set<string>([
  ...BROKER_SHIPPER_SIDEBAR_NOTIFICATION_TYPES.payments,
  ...CARRIER_SIDEBAR_NOTIFICATION_TYPES.payments,
]);

export const SIDEBAR_OPS_PO_INDEPENDENT_TYPES = new Set<string>([
  ...PAYMENTS_OPS_TYPES,
  NOTIFICATION_TYPES.PARTNERSHIP_CREATED,
  NOTIFICATION_TYPES.SHIPMENT_ARCHIVED,
]);

export function isSidebarOpsPoIndependentType(type: unknown): boolean {
  return typeof type === 'string' && SIDEBAR_OPS_PO_INDEPENDENT_TYPES.has(type);
}
